var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.icon != null
    ? _c("span", [
        typeof _vm.icon == "string"
          ? _c("span", { class: [_vm.icon], attrs: { "aria-hidden": "true" } })
          : _c("span", { domProps: { innerHTML: _vm._s(_vm.icon.html) } })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }